/**
 * Handles form animation and validations.
 */

import "@babel/polyfill";

(($) => {
    const labels = $('.customSelectInput__label');
    const options = $('.customSelectInput__options');
    const filterForm = $('.postFilterForm');
    const searchForm = $('.postSearch');
    const filterBtn = $('#cta_archive_filters__filters');
    const filter_close = $('.filter_row--close');
    const filters = ['brand', 'industry', 'pump', 'post', 'rate', 'head', 'temp'];
    const sort = $('.products_list_intro--sort_sort');
    const pathName = window.location.pathname;
    const ctaFilterRow = $('.cta_archive_filters');
    let submitBtn;

    function submitBtnPostFilterSet(){
        if ( $(window).width() < 1300 ) {
            submitBtn = $('.postFilter__mobile-btn .postFilter--btn');
        }
        else {
            submitBtn = $('.postFilter--btn--primary');
        }
    }

    submitBtnPostFilterSet();

    $(window).resize(function() {
        submitBtnPostFilterSet();
    });

    // if the current path contains 'categories'
    if (pathName.includes('/categories')) {
        // get the category name from the URL after /categories/
        const category = pathName.split('/categories/')[1].replace('/', '');
    
        // get the category id from the wordpress catalogue taxonomies 
        const filter = $(`#${category}`);
    
        if (filter.length > 0) {
            const parentElement = filter.parent().parent();
            const nextElement = parentElement.next();
    
            filter.prop('checked', true);
            parentElement.find('.customSelectInput__options--count').text('1 selected');
            nextElement.addClass('optionSelected');
            nextElement.children('.customSelectInput__options--count').text('- 1 selected');
        }
    }

    /** Toggles the active class on the given element and its previous sibling.
     * @param {jQuery} element - The element to toggle the active class on.
     */
    function toggleActive(element) {
        element.toggleClass('active');
        element.prev().toggleClass('active');
    }
    
    labels.on('click', function() {
        const $this = $(this);
        labels.not($this).removeClass('active');
        options.not($this.prev()).removeClass('active');
        toggleActive($this);

        if (window.innerWidth > 1300) {
            const optionsPanel = $this.prev();
            const optionsPanelHeight = optionsPanel.height();
            const optionsPanelOffset = optionsPanel.offset().top;
            const windowHeight = window.innerHeight;
            const windowScroll = $(window).scrollTop();
            const windowBottom = windowHeight + windowScroll;
            const optionsPanelBottom = optionsPanelHeight + optionsPanelOffset;
            if (optionsPanelBottom < windowBottom) {
                if (windowHeight - optionsPanelOffset - 20 > 400)
                {
                    optionsPanel.css('max-height', windowHeight - optionsPanelOffset - 20 + 'px');
                } else {
                    optionsPanel.css('max-height', '400px');
                }
                optionsPanel.css('overflow-y', 'scroll');
            } else {
                optionsPanel.css('max-height', '');
                optionsPanel.css('overflow-y', '');
            }
        }
        else {
            // mobile filters scroll to top on open, so new filter is visible as you'd expect
            let single_filter_offset = $this.offset().top;
            let container_offset = $('.filter_row').offset().top;
            let distance_for_scroll = single_filter_offset - container_offset;

            $('.filter_row').animate({
                scrollTop: distance_for_scroll
            }, 600);
        }
    });
    
    $('.customSelectInput__option').off('click').on('click', function(e) {
        e.preventPropagation;
        const clicked = $(this);
        const label = clicked.parent().next();
        const parent = clicked.parent();

        if (parent.parent().hasClass('postFilter')) {
            const selectedOptions = parent.find('input:checked').length;
            const optionsCountText = selectedOptions + ' selected';
            
            label.toggleClass('optionSelected', selectedOptions > 0);
            if (selectedOptions > 0) {
                label.find('.customSelectInput__options--count').text('- ' + optionsCountText);
            } else {
                label.find('.customSelectInput__options--count').text('');
                // trigger the postFilter__clear click event
                parent.find('.postFilter__clear').trigger('click');
                return;
            }
            parent.find('.customSelectInput__options--count').text(optionsCountText);

            const isDisabled = $('.customSelectInput__label.optionSelected').length === 0;

            submitBtn.prop('disabled', isDisabled);
        } else {
            if (this.children[0].checked) {
                this.children[0].checked = false;
            } else {
                this.children[0].checked = true;
            }
            label.find('.customSelectInput__label-text').text(clicked.text());
            label.toggleClass('optionSelected');
            // if no options are selected, 
            if (parent.find('input:checked').length === 0) {
                toggleActive(label);
            }
            if(parent.parent().hasClass('bespokeSelectInput')){
                parent.removeClass('active');
                label.removeClass('active');
            }
        }
    });

    // if options hasClass active and user clicks outside  labels or options, remove active class
    $(document).on('click', function(e) {
        if (!labels.is(e.target) && labels.has(e.target).length === 0 && !options.is(e.target) && options.has(e.target).length === 0) {
            labels.removeClass('active');
            options.removeClass('active');
        }  
    });

    const params = new URLSearchParams(window.location.search);

    /**
     * Handles the URL parameters and updates the form accordingly.
     * @param {string} paramName - The name of the parameter to handle.
     * @param {URLSearchParams} params - The URLSearchParams object containing the parameters.
     * @param {jQuery} submitBtn - The submit button element.
     */
    function handleParams(paramName, params, submitBtn) {
        if (params.has(paramName)) {
            const dropdown = $(`.postFilter__${paramName}`);
            const items = params.get(paramName).split(',');
    
            if (items.length > 0 && items[0] !== "") {
                items.forEach(function(item) {
                    dropdown.find(`input[value="${item}"]`).prop('checked', true);
                });
                dropdown.find('.customSelectInput__label').addClass('optionSelected');
                dropdown.find('.customSelectInput__options--count').text(items.length + ' selected');
            }
        }
    }

    // check if the URL has parameters and update the form accordingly
    if (params.has('brand') || params.has('pump') || params.has('industry') || params.has('post') || params.has('rate') || params.has('head') || params.has('temp') ){
        submitBtn.text('Update Filters').prop('disabled', true);
    
        filters.forEach(paramName => handleParams(paramName, params, submitBtn));
    } else {
        if (pathName === '/blog/') {
            const postFilter = $('.postFilter__post');
            const blogs = postFilter.find('.customSelectInput__option');
            blogs.each(function() {
                $(this).trigger('click');
            });
            const blog = $('.postFilter__post .customSelectInput__options');
            blog.next().addClass('optionSelected');
            blog.find('.customSelectInput__options--count').text('3 selected');
            blog.next().find('.customSelectInput__options--count').text('-3 selected');
        } else if (pathName === '/case-studies/') {
            const caseStudies = $('.customSelectInput__option[for="case-studies"]');
            caseStudies.trigger('click');
            caseStudies.parent().next().addClass('optionSelected');
            caseStudies.prev().find('.customSelectInput__options--count').text('1 selected');
            caseStudies.parent().next().find('.customSelectInput__options--count').text('-1 selected');
        }
    }

    // check if the URL has a search parameter and update the form accordingly
    if (params.has('sort')) {
        const sortValue = params.get('sort');
        const sortBtn = $('button#productsSort > .btn-text');
        const sortLabel = $(`button#productsSort `).parent().find(`label[for="${sortValue}"]`).text();
        if ( window.innerWidth < 1300  && window.innerWidth > 768) {
            $('#cta_archive_filters__sort > .btn-text').text(sortLabel);
        } else {    
            sortBtn.text(sortLabel);
        }
        if ( window.innerWidth < 1300 ) {
            $(`input[id="${sortValue}"]`).prop('checked', true);
        } else {
            $('.products_list_intro--sort').find(`input[id="${sortValue}"]`).prop('checked', true);
        }
    } else {
        if ( window.innerWidth < 1300 ) {
            $(`input[id="default"]`).prop('checked', true);
            // set label text to d
        } else {
            $('.products_list_intro--sort').find(`input[id="default"]`).prop('checked', true);
        }
    }

    // clear filters
    $('.postFilter__clear').on('click', function(e) {
        e.preventDefault();
        const parentElement = $(this).parent().parent();
        parentElement.find('input').prop('checked', false);
        parentElement.next().removeClass('optionSelected');
        $(this).prev().text('0 selected');
        parentElement.next().find('.customSelectInput__options--count').text('');
        const isDisabled = $('.customSelectInput__label.optionSelected').length === 0 && params.size === 0;
        // if the submit button is disabled and there are no filters selected, change the button text to 'Reset Filters'
        if ($('.customSelectInput__label.optionSelected').length === 0 && params.size > 0) {
            submitBtn.text('Reset Filters');
        }
        submitBtn.prop('disabled', isDisabled);
    });

    // Filter Form Submit
    filterForm.on('submit', function(e) {
        e.preventDefault();
        $('.postFilter--btn').prop('disabled', true);
        $('.postFilter--btn').html('<div class="btn-spinner"></div>');
        const query = new URLSearchParams();
        // Retrieves the filter values based on the given type.
        filters.forEach(type => {
            if ( $(`.postFilter__${type}`) ) {
                const values = $(`.postFilter__${type}`).find('input:checked')
                    .map(function() { return $(this).val(); })
                    .get()
                    .join(',');
                if (values !== '') {
                    query.set(type, values);
                }
            }
        });
        // Retrieves the search value from the search form.
        if (searchForm && searchForm.length > 0) {
            if (params.has('post_s') && searchForm.find('input[type="search"]').val() == params.get('post_s') ) {
                query.set('post_s', params.get('post_s'));
            } else if (searchForm.find('input[type="search"]').val() !== '') {
                query.set('post_s', searchForm.find('input[type="search"]').val());
            }
        }
        // Redirects to the catalogue page with the updated query parameters.
        if (pathName === '/' || pathName.includes('/categories')){
            if (query.size > 0) {
                window.location.href = '/catalogue/?' + query.toString();
            }
            else {
                window.location.href = '/catalogue/';
            }
        } 
        else {
            if (query.size > 0) {
                window.location.href = pathName + '?' + query.toString();
            } else {
                window.location.href = pathName;
            }
        }
    });

    // Archive Page Search
    searchForm.on('submit', function(e) {
        e.preventDefault();
        const query = new URLSearchParams();
        const searchInput = $(this).find('input[type="search"]');
        query.set('post_s', searchInput.val());

        /**
         * Retrieves the filter values based on the given type and parameters.
         *
         * @param {string} type - The type of filter.
         * @param {URLSearchParams} params - The URLSearchParams object containing the parameters.
         * @returns {string} - The filter values.
         */
        function getFilterValues(type, params) {
            const currentValues = $(`.postFilter__${type}`).find('input:checked')
                .map(function() { return $(this).val(); })
                .get()
                .join(',');
        
            if (params.has(type)) {
                const paramValues = params.get(type);
                if (paramValues === currentValues) {
                    return paramValues;
                }
            }
        
            return currentValues;
        }
        
        ['industry', 'pump', 'post'].forEach(type => {
            const values = getFilterValues(type, params);
            if (values !== '') {
                query.set(type, values);
            }
        });

        window.location.href = pathName + '?' + query.toString();
    });

    // mobile filter button
    if (window.innerWidth < 1300) {
        $(window).on('scroll', function() {
            if (window.scrollY > 30) {
                ctaFilterRow.addClass('active');
            } else {
                ctaFilterRow.removeClass('active');
            }
        });

        $('#cta_archive_filters__sort').on('click', function() {
            $(this).toggleClass('active');
            $('.productSort-mobile').toggleClass('active');
        });
    }

    // filter button
    filterBtn.on('click', (e) => {
        e.preventDefault();
        ctaFilterRow.hide();
        $('body').toggleClass('overflow-hidden');

        const header = $('header.header');
        const headerHeight = header.height();

        $('.filter_row').toggleClass('filter_row--active ').css('top', headerHeight + 'px');

        $('main').toggleClass('relative');
    });

    // filter close button
    filter_close.on('click', () => {
        ctaFilterRow.show();
        $('body').toggleClass('overflow-hidden');
        $('.filter_row').toggleClass('filter_row--active');
    });

    // sort dropdown
    sort.on('click', function() {
        $('.productSort').addClass('active');
    });

    // sort dropdown close
    if (sort.length > 0) {
        $(document).on('click', function(e) {
            if (!sort.is(e.target) && sort.has(e.target).length === 0) {
                $('.productSort').removeClass('active');
            }
        });

        $('.sortOption').on('click', function() {
            const clicked = $(this);
            const value = clicked.find('.tpfl-check').val();
            if ( value === 'default' ) {
                 // remove the sort parameter from the URL
                let url = window.location.href;
                if (url.includes('?sort')) {
                    url = url.replace(/\?sort=[^&]*/, '');
                    // If '?sort' was the only parameter, it will leave a trailing '?'. Remove it.
                    if (url.endsWith('?')) {
                        url = url.slice(0, -1);
                    }
                } else if (url.includes('&sort')) {
                    url = url.replace(/&sort=[^&]*/, '');
                }
                window.location.href = url;
                return;
            }
            if ( window.innerWidth < 1300 ) {
                $('#cta_archive_filters__sort').toggleClass('active');
            }
            const url = window.location.href;
            if (url.includes('?sort') || url.includes('&sort')) {
                const newUrl = url.includes('&sort') ? url.replace(/&sort=[^&]*/, `&sort=${value}`) : url.replace(/sort=[^&]*/, `sort=${value}`);
                window.location.href = newUrl;
                return;
            } else {
                const newUrl = url.includes('?') ? `${url}&sort=${value}` : `${url}?sort=${value}`;
                window.location.href = newUrl;
            }
        });
    }

})(jQuery);